import { render, staticRenderFns } from "./CatalogInstances.vue?vue&type=template&id=325752b2&lang=html"
import script from "./CatalogInstances.vue?vue&type=script&lang=ts"
export * from "./CatalogInstances.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports